import axios from 'axios';
import { authService } from '@/services/security';
import isOnline from 'is-online';
import { store } from '@/store';

export function initAxios() {
  axios.interceptors.request.use(async config => {
    const online = await isOnline();
    if (!online) {
      return config;
    }
    let accessToken = await authService.getAccessToken();
    config.headers.Authorization = 'Bearer ' + accessToken;
    store.commit('incrementLoading');
    return config;
  }, (error) => {
    store.commit('decrementLoading');
    return Promise.reject(error)
  });

  axios.interceptors.response.use(
    res => {
      store.commit('decrementLoading');
      return res;
    },
    async err => {
      const originalConfig = err.config;
      store.commit('decrementLoading');
      if (err.response) {
        // Access Token was expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;

          try {
            const accessToken = await authService.refreshToken();
            originalConfig.headers.Authorization = 'Bearer ' + accessToken;;

            return axios(originalConfig);
          } catch (_error) {
            if (_error.response && _error.response.data) {
              return Promise.reject(_error.response.data);
            }

            return Promise.reject(_error);
          }
        }

        if (err.response.status === 403 && err.response.data) {
          return Promise.reject(err.response.data);
        }
      }
    }
  );
}
